import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

// 虚拟滚动组件
import VueVirtualScroller from 'vue-virtual-scroller'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'

import App from './App.vue'
import router from './router'
import permission from './directives/permission'
import { useSettingsStore } from '@/stores/settings'

// 引入主题系统
import './styles/variables.css'
import './styles/global.css'
import './styles/themes/openclaw.css'
import './styles/themes/openclaw-light.css'
import './styles/themes/cool.css'
import './styles/themes/warm.css'
import './styles/themes/process-management.css'
// 引入移动端适配样式
import './styles/mobile.css'

const app = createApp(App)

// 注册所有 Element Plus 图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

// 创建 pinia 实例并添加持久化插件
const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

app.use(pinia)
app.use(router)
app.use(ElementPlus)
app.use(VueVirtualScroller)

// 注册权限指令
app.directive('permission', permission)

// 初始化主题系统（在挂载前执行）
const settingsStore = useSettingsStore()
settingsStore.initTheme()

// 全局错误处理器 - P2级边缘情况处理
app.config.errorHandler = (err, _instance, info) => {
  // 防止白屏，显示友好的错误提示
  console.error('全局错误捕获:', err, info)

  // 避免循环错误
  if (typeof window !== 'undefined' && !window.__errorHandlerTriggered__) {
    window.__errorHandlerTriggered__ = true

    // 显示用户友好的错误提示
    const errorMessage = err instanceof Error ? err.message : '发生未知错误'
    const ElementPlusMessage = (window as any).ElMessage
    if (ElementPlusMessage) {
      ElementPlusMessage.error({
        message: `页面出现错误: ${errorMessage}`,
        duration: 5000,
        showClose: true
      })
    }

    // 重置错误标记（5秒后允许再次触发）
    setTimeout(() => {
      window.__errorHandlerTriggered__ = false
    }, 5000)
  }
}

// 全局警告处理器（开发环境）
if (import.meta.env.DEV) {
  app.config.warnHandler = (msg, _instance, trace) => {
    console.warn('Vue警告:', msg, trace)
  }
}

app.mount('#app')
